import { useMutation } from 'react-query';
import {
  createTuyaIntegrationAsync,
  getTuyaIntegrationByIdAsync,
  deleteTuyaIntegrationAsync,
  updateTuyaIntegrationAsync,
} from '../..';

export const useCreateTuyaIntegrationAsync = () =>
  useMutation(createTuyaIntegrationAsync);

export const useGetTuyaIntegrationByIdAsync = () =>
  useMutation(getTuyaIntegrationByIdAsync);

export const useUpdateTuyaIntegrationAsync = () =>
  useMutation(updateTuyaIntegrationAsync);

export const useDeleteTuyaIntegrationAsync = () =>
  useMutation(deleteTuyaIntegrationAsync);
